import { IFormFieldState } from '../../../FormFieldSet';
import { Text } from '@chakra-ui/react';

const SimpleFieldHeader = (ffd: IFormFieldState) => {
  return (
    <Text textStyle="headingItem">
      {ffd.formFieldDefinition.params.labels.main}
    </Text>
  );
};

export default SimpleFieldHeader;
